export const FLUSH_SEQUENCE: 'SEQUENCES/FLUSH_ALL' = 'SEQUENCES/FLUSH_ALL';
export const START_SEQUENCE: 'SEQUENCE/START' = 'SEQUENCE/START';
export const FINISH_SEQUENCE: 'SEQUENCE/FINISH' = 'SEQUENCE/FINISH';
